const rail = {
  rails: "القضبان", // translated 
  senior: "كبير", // translated 
  seniors: "كبار السن", // translated 
  youths: "شباب", // translated 
  yearOld: "سنه", // translated 
  yearsOld: "سنة", // translated 
};



export default rail;
